import styled from 'styled-components'

export const Styles = {
  Root: styled.div`
    width: 100%;
    max-height: 176px;
    position: absolute;
    top: 70px;
    left: 0;
    border-radius: 20px;
    background: ${({ theme }) => theme.colors.emailAutocompleteBackground};
    box-shadow: ${({ theme }) => theme.common.emailAutocompleteBoxShadow};
    overflow-y: auto;
  `,

  Button: styled.button`
    width: 100%;
    height: 44px;
    padding: 0 16px;
    display: flex;
    justify-content: end;
    align-items: center;
    cursor: pointer;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 44px;
    text-decoration: none;
    text-align: left;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    background-color: transparent;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    direction: rtl;

    &:hover {
      background: ${({ theme }) => theme.colors.emailAutocompleteHoverColor};
      background-image: url(${({ theme }) => theme.images.checkIcon});
      background-size: 24px 24px;
      background-repeat: no-repeat;
      background-position: center right 5%;
    }
  `,

  Text: styled.span`
    unicode-bidi: plaintext;
  `,
} as const
